<template>
  <section class="page-section">
    <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
      <el-tab-pane label="首页广告" name="1"></el-tab-pane>
      <el-tab-pane label="服务页面广告" name="2"></el-tab-pane>
      <el-tab-pane label="商品页面广告" name="3"></el-tab-pane>
      <el-tab-pane label="广告详情页" name="4"></el-tab-pane>
    </el-tabs>

    <el-button
      type="primary"
      class="btn-add-block"
      :disabled="tableData.length > 5"
      @click="pageNavigateToShopAdvAdd(1)"
      >新建{{
        tabName == "1"
          ? "首页广告"
          : tabName == "2"
          ? "服务页面广告"
          : tabName == "3"
          ? "商品页面广告"
          : "广告详情页"
      }}</el-button
    >

    <!-- table -->
    <div class="table-region" v-loading="tableLoading">
      <template v-if="tabName == '1' || tabName == '2' || tabName == '3'">
        <el-table size="small" :data="tableData">
          <el-table-column label="标题">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <div class="thumb-wrap">
                <img :src="scope.row.picPath" style="pointer-events: none" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="链接至">
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.redirectType == 1 ||
                  scope.row.redirectType == 3 ||
                  scope.row.redirectType == 6
                "
                >{{ scope.row.productName }}</template
              >
              <template
                v-if="
                  scope.row.redirectType == 2 || scope.row.redirectType == 4
                "
                >{{ scope.row.firstCategoryName }} -
                {{ scope.row.secondCategoryName }}</template
              >
            </template>
          </el-table-column>
          <el-table-column label="最后编辑时间">
            <template slot-scope="scope">
              <p>{{ COMMON.formatDate("2", "-", scope.row.lastUpdateDate) }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right" width="200">
            <template slot-scope="scope">
              <!-- 下线 -->
              <el-popover
                placement="top"
                width="160"
                v-model="scope.row.downVisible"
                popper-class="confirm-popover"
              >
                <p>确定{{ scope.row.status == 1 ? "上线" : "下线" }}？</p>
                <div>
                  <el-button
                    size="small"
                    type="default"
                    plain
                    @click="scope.row.downVisible = false"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="downVisibleTrue(scope.row, scope.$index)"
                    :loading="popupLoading"
                    >确定</el-button
                  >
                </div>

                <el-button size="small" type="text" slot="reference">{{
                  scope.row.status == 1 ? "上线" : "下线"
                }}</el-button>
              </el-popover>

              <!-- 编辑 -->
              <el-button
                size="small"
                type="text"
                @click="pageNavigateToShopAdvAdd(2, scope.row)"
                >编辑</el-button
              >

              <!-- 删除 -->
              <el-popover
                placement="top"
                width="160"
                v-model="scope.row.deleteVisible"
                popper-class="confirm-popover"
              >
                <p>确定删除？</p>
                <div>
                  <el-button
                    size="small"
                    type="default"
                    plain
                    @click="scope.row.deleteVisible = false"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="deleteVisibleTrue(scope.row, scope.$index)"
                    :loading="deleteLoading"
                    >确定</el-button
                  >
                </div>

                <el-button size="small" type="text" slot="reference"
                  >删除</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-if="tabName == '4'">
        <el-table size="small" :data="tableData">
          <el-table-column label="详情页标题">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Banner位置">
            <template slot-scope="scope">
              <span>{{ scope.row.banner }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最后编辑时间">
            <template slot-scope="scope">
              <p>{{ COMMON.formatDate("2", "-", scope.row.lastUpdateDate) }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right" width="200">
            <template slot-scope="scope">
              <!-- 编辑 -->
              <el-button
                size="small"
                type="text"
                @click="pageNavigateToShopAdvAdd(2, scope.row)"
                >编辑</el-button
              >

              <!-- 删除 -->
              <el-popover
                placement="top"
                width="160"
                v-model="scope.row.deleteVisible"
                popper-class="confirm-popover"
              >
                <p>确定删除？</p>
                <div>
                  <el-button
                    size="small"
                    type="default"
                    plain
                    @click="scope.row.deleteVisible = false"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="deleteVisibleTrue(scope.row, scope.$index)"
                    :loading="deleteLoading"
                    >确定</el-button
                  >
                </div>

                <el-button size="small" type="text" slot="reference"
                  >删除</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!-- <div class="table-footer">
                        <div class="selection-operate"></div>

                        <div class="pagination-wrap" v-if="page.total > 0">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[20, 50, 100]"
                                :page-size.sync="page.size"
                                :current-page="page.current"
                                :pager-count="7"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="page.total">
                            </el-pagination>
                        </div>
                    </div> -->
    </div>
  </section>
</template>

<script>
import {
  shopAdvPopWindowList,
  shopAdvBannerList,
  shopAdvShowManage,
  shopAdvPopWindowDelete,
  shopMyPageList,
  shopBusinessTypeList,
  shopAdvPopWindowUpdown,
  shopAdvBannerSort,
} from "@/common/api";
import {
  COMMON,
  shopPosterList,
  shopPosterUpDown,
  shopPosterDelete,
  shopPosterSort,
  shopPosterPageList,
  shopPosterPageSort,
  shopPosterPageDelete,
} from "@/common/api";
import Vue from "vue";

export default {
  data() {
    return {
      COMMON,

      page: {
        current: 1, // 当前页
        size: 20, // 每页条数
        total: "", // 总条数
      },

      tabName: this.$route.query.tabname ? this.$route.query.tabname : "1", // 选项卡name
      sortM: "", // 需排序标记

      tableLoading: false, // 表格加载
      popupLoading: false, // 上下线二次弹窗确定加载
      deleteLoading: false, // 删除二次弹窗确定加载
      tableData: [], // 表格数据
    };
  },
  watch: {
    /**
     * [description] 监听表单数据变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    tableData: function (val) {
      this.$nextTick(function () {
        this.handleTableRowSort();
      });
    },
  },
  methods: {
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList() {
      if (this.tabName == 4) {
        // 详情页广告
        this.tableLoading = true;
        var params = {
          size: this.page.size,
          current: this.page.current,
        };
        shopPosterPageList(params)
          .then((res) => {
            if (res.code == 0) {
              this.tableLoading = false;
              this.tableData = res.data.records;
              this.page.total = res.data.total;
            } else {
              this.$message({ message: res.msg, type: "error" });
            }
          })
          .catch((error) => {
            this.tableLoading = false;
            this.$message.error("服务器异常");
          });
      } else {
        this.tableLoading = true;
        var params = {
          adType: this.tabName,
          pageSize: this.page.size,
          pageNo: this.page.current,
        };
        shopPosterList(params)
          .then((res) => {
            if (res.code == 0) {
              this.tableLoading = false;
              this.tableData = res.data.records;
              this.page.total = res.data.total;
            } else {
              this.$message({ message: res.msg, type: "error" });
            }
          })
          .catch((error) => {
            this.tableLoading = false;
            this.$message.error("服务器异常");
          });
      }
    },
    /**
     * [downVisibleTrue description] 上下线二次弹窗确定事件
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    downVisibleTrue(scopeRow, index) {
      this.popupLoading = true;
      var params = {
        posterId: scopeRow.id,
        status: scopeRow.status == 1 ? 0 : 1,
      };
      shopPosterUpDown(params)
        .then((res) => {
          this.popupLoading = false;
          if (res.code == 0) {
            scopeRow.downVisible = false;
            if (scopeRow.status == 1) {
              this.getList();
              this.$message({ message: "上线成功", type: "success" });
            } else {
              this.getList();
              this.$message({ message: "下线成功", type: "success" });
            }
          } else {
            this.$message({ message: res.msg, type: "error" });
          }
        })
        .catch((error) => {
          this.popupLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [deleteVisibleTrue description] 删除二次弹窗确定事件
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    deleteVisibleTrue(scopeRow, index) {
      if (this.tabName == 4) {
        this.deleteLoading = true;
        var params = {
          posterPageId: scopeRow.id,
        };
        shopPosterPageDelete(params)
          .then((res) => {
            this.deleteLoading = false;
            if (res.code == 0) {
              scopeRow.deleteVisible = false;
              this.getList();
              this.$message({ message: "删除成功", type: "success" });
            } else {
              this.$message({ message: res.msg, type: "error" });
            }
          })
          .catch((error) => {
            this.deleteLoading = false;
            this.$message.error("服务器异常");
          });
      } else {
        this.deleteLoading = true;
        var params = {
          posterId: scopeRow.id,
        };
        shopPosterDelete(params)
          .then((res) => {
            this.deleteLoading = false;
            if (res.code == 0) {
              scopeRow.deleteVisible = false;
              this.getList();
              this.$message({ message: "删除成功", type: "success" });
            } else {
              this.$message({ message: res.msg, type: "error" });
            }
          })
          .catch((error) => {
            this.deleteLoading = false;
            this.$message.error("服务器异常");
          });
      }
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange(tab, event) {
      this.tabName = tab.name;
      this.page.current = 1;
      this.page.size = 20;
      this.getList();
      this.$router.push({
        path: "/shop/adv/list",
        query: { tabname: this.tabName },
      });
    },
    /**
     * [pageNavigateToShopAdvAdd description] 跳转编辑/新增
     * @param  {[type]} val   [description]
     * @return {[type]}       [description]
     */
    pageNavigateToShopAdvAdd(type, scopeRow) {
      if (type == 1) {
        this.$router.push({
          path: "/shop/adv/add",
          query: { tabname: this.tabName },
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/shop/adv/add",
          query: { tabname: this.tabName, id: scopeRow.id },
        });
      }
    },
    /**
     * [handleTableRowSort description] 给表格每一行绑定移动事件
     * @return {[type]} [description]
     */
    handleTableRowSort: function () {
      let tableTR = document
        .getElementsByClassName("el-table__body")[0]
        .getElementsByTagName("tr");

      for (let i = 0; i < tableTR.length; i++) {
        let tableTRItem = tableTR[i];

        tableTRItem.draggable = true;
        tableTRItem.setAttribute("data-index", i);
        tableTRItem.setAttribute("data-id", this.tableData[i].id);
        tableTRItem.setAttribute("data-order", this.tableData[i].sequence);
        tableTRItem.style.cursor = "all-scroll";

        tableTRItem.removeEventListener(
          "dragstart",
          this.handleTableTRDragStart,
        );
        tableTRItem.addEventListener(
          "dragstart",
          this.handleTableTRDragStart,
          false,
        );

        tableTRItem.removeEventListener("dragover", this.handleTableTRDragover);
        tableTRItem.addEventListener(
          "dragover",
          this.handleTableTRDragover,
          false,
        );

        tableTRItem.removeEventListener("drop", this.handleTableTRDrop);
        tableTRItem.addEventListener("drop", this.handleTableTRDrop, false);
      }
    },
    /**
     * [handleTableTRDragStart description] 拖动开始，设置携带的参数
     * @param  {[type]} ev [description] 拖动对象
     * @return {[type]}    [description]
     */
    handleTableTRDragStart: function (ev) {
      ev.dataTransfer.setData("index", ev.target.dataset.index);
      ev.dataTransfer.setData("id", ev.target.dataset.id);
      ev.dataTransfer.setData("order", ev.target.dataset.order);
    },
    /**
     * [handleTableTRDragover description] 必须要 preventDefault, 否则不会触发 drop
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    handleTableTRDragover: function (ev) {
      ev.preventDefault();
    },
    /**
     * [handleTableTRDrop description] 拖动释放触发的方法
     * @param  {[type]} ev [description] 目标对象
     * @return {[type]}    [description]
     */
    handleTableTRDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData("index"),
        originalId = ev.dataTransfer.getData("id"),
        originalOrder = ev.dataTransfer.getData("order"),
        trNode = this.handleGetTRNode(ev.target),
        targetIndex = trNode.getAttribute("data-index"),
        targetOrder = trNode.getAttribute("data-order");

      if (originalIndex == targetIndex) {
        // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.tableData.splice(originalIndex, 1);
      this.tableData.splice(targetIndex, 0, originalObject[0]);

      // do request
      this.tableLoading = true;

      let params = {
        sourceId: originalId,
        sourceOrder: originalOrder,
        targetOrder: targetOrder,
      };

      if (this.tabName == 4) {
        shopPosterPageSort(params)
          .then((res) => {
            let { code, data, msg } = res;

            if (code == 0) {
              this.tableLoading = false;
              this.$message({ message: "移动成功", type: "success" });
              this.getList();
            } else {
              this.$message.error(msg);
            }
          })
          .catch((error) => {
            this.tableLoading = false;
            this.$message.error("服务器异常");
          });
      } else {
        shopPosterSort(params)
          .then((res) => {
            let { code, data, msg } = res;

            if (code == 0) {
              this.tableLoading = false;
              this.$message({ message: "移动成功", type: "success" });
              this.getList();
            } else {
              this.$message.error(msg);
            }
          })
          .catch((error) => {
            this.tableLoading = false;
            this.$message.error("服务器异常");
          });
      }
    },
    /**
     * [handleGetTRNode description] 循环查找dom父节点，直到匹配到tr
     * @param  {[type]} ob [description] 当前dom节点
     * @return {[type]}    [description]
     */
    handleGetTRNode: function (ob) {
      if (ob.tagName == "TR") {
        return ob;
      } else {
        return this.handleGetTRNode(ob.parentNode);
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

::v-deep .el-table td div.thumb-wrap {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  width: 48px;
  height: 48px;
  background-color: $colorPageBg;

  img {
    max-width: 100%;
    max-height: 100%;
    @include position(absolute, 1, 50%, none, none, 50%);
    @include translate(-50%, -50%, 0);
  }
}

.filter-region.switch-center {
  height: 68px;

  span {
    font-size: 12px;
    color: $textColor;
    margin-right: 50px;
  }
}
</style>
